// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "a2289b546419ee959a94" + ".chunk.js";
};